
import React, { useState } from 'react';
import './style.css'
import Button from '@material-ui/core/Button';
import emailjs from 'emailjs-com'

import Alert from 'react-bootstrap/Alert'

const Contatos = () => {
    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('gmail', 'meu_email_aq', e.target, 'user_KbvGar2N05df6j27Lq50D')
            .then((result) => {
                console.log(result.text);
                alert('Email encaminhado ')

            }, (error) => {
                console.log(error.text);

            });
        e.target.reset()


    }

    return (

        <>
            <div className="container ">
                <h2 className="teste">Contato</h2>
                <p>Quer me mandar um email ? Basta preencher esses campos que entro em contato com você :)  </p>
                 
                <form  className="contact-form" onSubmit={sendEmail} >
                    <div className="row">

                        <div className="col-md-4 text-message">
                            <div className="form-group ">
                                <label>Email</label>
                                <input type="email" name="email" placeholder="Nome@gmail.com" className="form-control" required="True" />
                            </div>
                        </div>

                        <div className="col-md-4 text-message">

                            <div className="form-group ">
                                <label>Nome</label>
                                <input type="text" name="nome" id="form-name" placeholder="Nome" className="form-control" required="True" />
                            </div>
                        </div>
                        <div className="col-md-4 text-message">

                            <div className="form-group ">
                                <label>Assunto </label>
                                <input type="text" name="assunto" id="form-name" placeholder="Assunto" className="form-control" required="True" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 text-message">
                        <div className="form-group ">
                            <label>Assunto principal</label>
                            <textarea name="assuntoPrincipal" className="form-control" placeholder="Mensagem de email" rows="8" required="True"></textarea>
                        </div>



                    </div>
                        <div className="pad">
                                <Button variant="outlined" type="submit" value="Send"  size="large" color="primary" >
                                Enviar
                        </Button>
                        </div>
                </form>
            </div>
        </>
    )
}

export default Contatos